import { render, staticRenderFns } from "./MessagePermissions.vue?vue&type=template&id=5f87b70a&scoped=true&"
import script from "./MessagePermissions.vue?vue&type=script&lang=js&"
export * from "./MessagePermissions.vue?vue&type=script&lang=js&"
import style0 from "./MessagePermissions.vue?vue&type=style&index=0&id=5f87b70a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87b70a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
